<template>
  <div class="button-div">
    <div class="div-chexbox-button">
      <ListMenuWithCheckbox
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone') &&
          (showZoneMenu || showZoneMenuHover)
        "
        :categories="categories"
        :title="$t('general__data__area-zones')"
        @onChecklistToggle="onChecklistToggle"
        @onHoverListMenu="$emit('onHoverListMenu')"
        @closeHoverListMenu="$emit('closeHoverListMenu')"
      />
      <ButtonSquareHoverChecklist
        :title="$t('general__data__area-zones')"
        :imgSource="require('@/assets/icons-general/icon-layers.svg')"
        size="large"
        style="padding-top: 24px"
        :activeState="zoneActiveState"
        @clicked="toggleVisible"
        @hovered="$emit('MapZoneButtonHovered')"
      />
    </div>
  </div>
</template>

<script>
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import ListMenuWithCheckbox from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_SHOW_ZONE_MENU } from '@/store/mutation-types'

export default {
  name: 'MapZonesButton',
  components: {
    ButtonSquareHoverChecklist,
    ListMenuWithCheckbox
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    showZoneMenuHover: {
      type: Boolean
    },
    title: {
      type: String,
      required: true
    }
  },
  emits: ['MapZoneButtonHovered', 'onHoverListMenu', 'onChecklistToggle', 'closeHoverListMenu'],
  data() {
    return {
      zoneLayers: []
    }
  },
  computed: {
    ...mapState({
      clickedItemType: (state) => state.clickedItemType,
      showZoneMenu: (state) => state.showZoneMenu
    }),
    ...mapGetters(MAPVIEW_PREFIX, {
      selectedRealEstateId: 'selectedRealEstateId'
    }),
    zoneActiveState() {
      if (!this.categories.length) {
        this.setShowZoneMenu(false)
        return 'deactivated'
      }
      if (this.showZoneMenu) {
        return 'active'
      } else {
        return 'inactive'
      }
    }
  },
  methods: {
    hideHoverButtons() {
      this.setShowZoneMenu(false)
    },
    toggleVisible() {
      if (this.zoneActiveState === 'deactivated') return
      this.setShowZoneMenu(!this.showZoneMenu)
    },
    onChecklistToggle(typeId, categoryId, checked) {
      this.$emit('onChecklistToggle', typeId, categoryId, checked)
    },
    ...mapMutations({
      setShowZoneMenu: SET_SHOW_ZONE_MENU
    })
  }
}
</script>

<style lang="scss" scoped>
.div-chexbox-button {
  display: flex;
  justify-content: center;
}
</style>
